import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { FinancialFormState } from "../store/reducers/financialFormReducer";
import { removeFinancialForm } from "../store/actions/financialForm";

export const useFinancialForm = (): FinancialFormState => {
  const dispatch = useDispatch();
  const state = useSelector((s: RootState) => s.financialFormReducer);
  const accessToken = useSelector((s: RootState) => s.userReducer.accessToken);
  const tempToken = useSelector((s: RootState) => s.userReducer.tempToken);

  useEffect(() => {
    if (state.financialForm && !accessToken && !tempToken) {
      dispatch(removeFinancialForm());
    }
  }, [state.financialForm, accessToken, tempToken, dispatch]);

  return state;
};
